'use client';

import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import type { GetAbilitiesModelView } from 'abi-genome-common-types';
import { isAxiosError } from 'axios';

import { getUserAbilities } from '~/shared/auth/genome';
import { genomeApi } from '~/shared/services/api';

export const USER_ABILITIES_QUERY_KEY = ['user-abilities'];

export function useUserAbilities() {
  const { data: session } = useSession();
  const token = session?.user?.tk;

  return useQuery<GetAbilitiesModelView | null>({
    queryKey: [...USER_ABILITIES_QUERY_KEY, token],
    queryFn: async () => {
      if (!token) return null;
      const result = await getUserAbilities(genomeApi, token);
      if (isAxiosError(result)) throw result;
      return result;
    },
    staleTime: 1000 * 60 * 30,
    enabled: !!token,
  });
}
